// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Search_wrapper__1NqGf","input":"Search_input__2h2L8","text":"Search_text__2zfyR"};